export default __webpack_public_path__ + "static/media/gallery_07.66792fb9.jpg";